import {gql} from "@apollo/client";
import {GET_USER_FIELDS} from "../queries/GetUser";

export const CANCEL_WITHDRAWAL_MUTATION = gql`
          ${GET_USER_FIELDS}
          mutation CancelWithdrawalMutation($withdrawalId: String!){
    cancelWithdrawal (
        withdrawalId: $withdrawalId
)
    { 
        ...GetUserFields
    }
}`;